// transitionDuration — a state-machine transition's crossfade, resolved from the
// edge's own data. A LEAF: no imports, so node:test can drive it directly
// (smRuntime.js reaches devLog through an extensionless import only a bundler
// resolves, which is why this does not live there).
//
/**
 * The crossfade a transition uses when it states none. Every state machine in
 * every blueprint used this, as a literal at GraphEvaluator's one call site, so
 * it stays the fallback: a transition that authors nothing is unchanged.
 */
export const DEFAULT_TRANSITION_S = 0.3

/**
 * A transition edge's crossfade in seconds, from its own `transitionDuration`
 * or the shared default.
 *
 * BLANK INHERITS, and 0 IS A VALUE. An authored 0 is a hard cut — the thing you
 * want when a reaction should snap rather than smear — so it must survive as
 * distinct from "not set". Anything that is not a finite number >= 0 (a
 * half-typed '-', a stale string, a null) reads as unset rather than as 0, or a
 * mid-edit keystroke would turn every transition into a cut.
 *
 * Upper bound: a crossfade evaluates BOTH states every frame it runs, so a
 * runaway value is a state machine that never finishes arriving. 10s is far
 * past any plausible blend and still finite.
 */
export function resolveTransitionDuration(edgeData) {
  const raw = edgeData?.transitionDuration
  if (raw === null || raw === undefined || raw === '') return DEFAULT_TRANSITION_S
  const n = Number(raw)
  if (!Number.isFinite(n) || n < 0) return DEFAULT_TRANSITION_S
  return Math.min(n, 10)
}
